import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';
import Video from '@components/UI/organisms/Video';
import type { PronunciationModalProps } from './pronunciation-modal.types';

export const PronunciationModal = ({
  ipa,
  englishSound,
  statusText,
  videoEmbedUrl,
  videoThumbStyle,
  onClose,
}: PronunciationModalProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="max-w-2xl mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>
            {t('modals.pronunciation.title')}: {ipa}
          </CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <div className="">
            <Video videoUrl={videoEmbedUrl} videoThumbStyle={videoThumbStyle} />
            <div className="pron-status">
              <p>
                <b className="mr-1">IPA:</b>
                <span> {ipa}</span>
              </p>
              <p>
                <b className="mr-1">{t('modals.pronunciation.pronounceAs')}:</b>
                <span>{englishSound}</span>
              </p>
              <p>
                <b className="mr-1">{t('modals.pronunciation.assessment')}:</b>
                <span>{statusText}</span>
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
